import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Column, ValueInTable } from '@/_shared/components';
import { Table } from '@/_shared/components/Table';
import { components } from '@/swagger/types/surveys';

type Employee = components['schemas']['EmployeeDto'];

type Props = {
  employees: Employee[];
};

export const TableNotInvitedEmployees: FC<Props> = ({ employees }) => {
  const t = useTranslations('surveys.campaign.reminderDialog.table');

  const columns: Column[] = [
    {
      key: 'name',
      title: t('name'),
      renderValue: (item: Employee) => (
        <ValueInTable>{`${item.firstName} ${item.lastName}`}</ValueInTable>
      ),
    },
    {
      key: 'role',
      title: t('role'),
      renderValue: (item: Employee) => <ValueInTable>{item.role || '-'}</ValueInTable>,
    },
    {
      key: 'email',
      title: t('mail'),
      renderValue: (item: Employee) => <ValueInTable>{item.email || '-'}</ValueInTable>,
    },
  ];

  return (
    <Table
      columns={columns}
      rowData={employees}
      cellContentProps={() => ({
        display: 'flex',
      })}
    />
  );
};
